import { Alert } from "@mui/material"
import { styled } from "@mui/styles"

export const StyledAlert = styled(Alert)(({ severity, theme: { typography, withPalette } }: any) => {
  return {
    "&.MuiAlert-root": {
      "& .MuiAlert-icon": {
        color: withPalette(severity),
        marginRight: typography.pxToRem(16),
      },
      "& .MuiAlert-message": {
        display: "flex",
        alignItems: "center",
        padding: 0,
      },
      borderRadius: 4,
      fontSize: typography.pxToRem(16),
      fontWeight: "bold",
      padding: [[typography.pxToRem(10), typography.pxToRem(12)]],
    },

    "&.MuiAlert-standardInfo": {
      backgroundColor: "#dbe5ff",
      borderColor: withPalette("info"),
      color: typography.color,
    },
  }
})
